import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationRoutingModule } from './registration-routing.module';
import { RegistrationComponent } from './registration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../auth/auth.service';
import { LoadingModule } from 'ngx-loading';

@NgModule({
  imports: [
    CommonModule,
    RegistrationRoutingModule,
    FormsModule,
    LoadingModule,
    ReactiveFormsModule
  ],
  declarations: [RegistrationComponent],
  providers: [AuthService]
})
export class RegistrationModule { }



// WEBPACK FOOTER //
// ./src/app/registration/registration.module.ts